import { Injectable } from '@angular/core';

import { ApiService } from '../api/api.service';
import { ListResponse } from '../../models/list-response';
import { CustomInbox, CustomInboxFilters, CustomInboxItem, CustomInboxItemFilters } from '../../models/custom-inbox';


@Injectable({
  providedIn: 'root'
})
export class CustomInboxService {
  constructor(
    private apiService: ApiService
  ) {}

  getCustomInboxes(pageNumber?: number,
                   pageSize?: number,
                   filters?: CustomInboxFilters): Promise<ListResponse<CustomInbox>> {
    return this.apiService.getCollection<CustomInbox, CustomInboxFilters>(
      'custom-inboxes/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getCustomInbox(id: number): Promise<CustomInbox> {
    return this.apiService.getItem<CustomInbox>(
      'custom-inboxes/',
      id
    );
  }

  addCustomInbox(inbox: CustomInbox): Promise<CustomInbox> {
    return this.apiService.postToAPI<CustomInbox>(
      'custom-inboxes/',
      {
        name: inbox.name,
        status: inbox.status,
        conditions: inbox.conditions,
        include_customer_profile_alert: inbox.include_customer_profile_alert,
        customer_profile_alert_color_hex: inbox.customer_profile_alert_color_hex,
        prevent_customer_check_in: inbox.prevent_customer_check_in,
        auto_resolve_time_hours: inbox.auto_resolve_time_hours,
        staff_instruction_text: inbox.staff_instruction_text,
      }
    );
  }

  updateCustomInbox(inbox: CustomInbox): Promise<CustomInbox> {
    return this.apiService.patchToAPI<CustomInbox>(
      inbox.url,
      {
        name: inbox.name,
        status: inbox.status,
        conditions: inbox.conditions,
        include_customer_profile_alert: inbox.include_customer_profile_alert,
        customer_profile_alert_color_hex: inbox.customer_profile_alert_color_hex,
        prevent_customer_check_in: inbox.prevent_customer_check_in,
        auto_resolve_time_hours: inbox.auto_resolve_time_hours,
        staff_instruction_text: inbox.staff_instruction_text,
      }
    );
  }

  getCustomInboxItems(pageNumber?: number,
                      pageSize?: number,
                      filters?: CustomInboxItemFilters): Promise<ListResponse<CustomInboxItem>> {
    return this.apiService.getCollection<CustomInboxItem, CustomInboxItemFilters>(
      'custom-inbox-items/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getCustomInboxItem(id: number): Promise<CustomInboxItem> {
    return this.apiService.getItem<CustomInboxItem>(
      'custom-inbox-items/',
      id
    );
  }

  resolveCustomInboxItem(inboxItemId: number): Promise<void> {
    return this.apiService.postToAPI<any>(
      'custom-inbox-items/' + inboxItemId.toString() + '/resolve/',
      {}
    ).then();
  }
}
